import { useEffect, useState, type RefObject } from 'react';

export function useNpcLineAudioProgress(
  lineKey: string,
  playingLineKey: string | null,
  audioRef: RefObject<HTMLAudioElement | null>
) {
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const isActive = playingLineKey === lineKey;

  useEffect(() => {
    if (!isActive) {
      setIsPlaying(false);
      return;
    }
    const audio = audioRef.current;
    if (!audio) return;

    setHasEnded(false);

    const sync = () => {
      setCurrentTime(audio.currentTime);
      setIsPlaying(!audio.paused);
    };

    const handleEnded = () => {
      setHasEnded(true);
      sync();
    };

    sync();
    const interval = window.setInterval(sync, 50);
    audio.addEventListener('timeupdate', sync);
    audio.addEventListener('seeked', sync);
    audio.addEventListener('play', sync);
    audio.addEventListener('pause', sync);
    audio.addEventListener('ended', handleEnded);

    return () => {
      window.clearInterval(interval);
      audio.removeEventListener('timeupdate', sync);
      audio.removeEventListener('seeked', sync);
      audio.removeEventListener('play', sync);
      audio.removeEventListener('pause', sync);
      audio.removeEventListener('ended', handleEnded);
    };
  }, [isActive, audioRef]);

  return { currentTime, isPlaying: isActive && isPlaying, hasEnded };
}
